import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[pgOffLabel], pg-off-label, [gritOffLabel], grit-off-label',
  exportAs: 'pgOffLabel, gritOffLabel',
})
export class PgOffSwitchLabelDirective {
  @HostBinding('class') _classList = 'pg-switch-on-label';

  constructor() {}
}

@Directive({
  selector: '[pgOnLabel], pg-on-label, [gritOnLabel], grit-on-label',
})
export class PgOnSwitchLabelDirective {
  @HostBinding('class') _classList = 'pg-switch-off-label';

  constructor() {}
}
